"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.platform = void 0;
exports.platform = {
  id: 'platform',
  label: 'Platform Admin',
  scopes: ['write:any', 'admin:any'],
  children: [{
    id: 'platform/members-teams',
    type: 'list-group',
    label: 'Members & Roles',
    entities: ['User', 'UserRole']
  }, {
    id: 'platform/web-content',
    type: 'list-group',
    label: 'Website Configuration',
    entities: ['Menu', 'MenuItem', 'PageLayout', 'SliceLayout', 'BlockLayout']
  }, {
    id: 'platform/gpt',
    type: 'list-group',
    label: 'GPT Configuration',
    entities: ['PromptTemplate', 'CompletionSource']
  }, {
    id: 'platform/rooms-venues',
    label: "Venues & Rooms",
    type: 'list-group',
    entities: ['Venue', 'Room']
  }, {
    id: 'platform/courses-lessons',
    label: "Courses & Lessons",
    type: 'list-group',
    entities: ['Course', 'Lesson']
  }, {
    id: 'platform/authors-publisher',
    label: "Authors & Publishers",
    type: 'list-group',
    entities: ['Author', 'Publisher', 'Editor']
  }, {
    id: 'platform/indicators-data',
    label: "Indicators & Data",
    type: 'list-group',
    entities: ['IndicatorGroup', 'Indicator', 'Variable', 'Unit', 'DataSet', 'IndicatorType', 'IndicatorGroupLayout', 'IndicatorLayout', 'ValueType']
  }, {
    id: 'platform/taxonomies',
    label: "Taxonomies",
    entityType: 'taxonomy',
    type: 'list-group'
  }]
};